module.exports = { id: "recycle", url: "/build/app/img/symbols.svg#recycle", viewBox: "", toString: function() { return this.url; } };